export const toRoleIdList = (roleIds) => {
  if (!roleIds) return [];
  if (Array.isArray(roleIds)) {
    return roleIds.map(String).filter(Boolean);
  }
  return String(roleIds)
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
};

export const normalizeRoleSource = (roles = []) =>
  (Array.isArray(roles) ? roles : []).map((role) => ({
    ...role,
    id: String(role.id ?? ''),
    name: role.name || role.role_name || role.job_role || role.role || String(role.id ?? ''),
  }));

/**
 * Resolve stored role ids to display names. While the role catalog is still loading,
 * unresolved numeric ids are omitted so the UI does not flash raw role ids.
 */
export const resolveAssessmentRoleNames = (roleIds, roleSource = []) => {
  const ids = toRoleIdList(roleIds);
  if (!ids.length) return [];

  const source = normalizeRoleSource(roleSource);
  const rolesReady = source.length > 0;

  return ids
    .map((id) => {
      const found = source.find(
        (role) =>
          String(role.id) === id ||
          String(role.name || '').toLowerCase() === id.toLowerCase()
      );
      if (found) {
        return found.name || found.role_name || found.job_role || found.role || '';
      }
      if (!rolesReady) {
        return '';
      }
      if (/^\d+$/.test(id)) {
        return '';
      }
      return id;
    })
    .filter(Boolean);
};
